import { RootState } from "store/store";
import { IAxisStyleSettings, IStyleSettings } from "./types";

export const selectedStyleSettings = (state: RootState): IStyleSettings => state.workspaceSlice.styleSettings
export const selectedAxisStyleSettings = (state: RootState): IAxisStyleSettings => state.workspaceSlice.axisStyleSettings
